import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export abstract class Commands {

  protected readonly ENDPOINT: string;

  protected client_id?: string;
  protected room_id?: string;

  constructor(protected http: HttpClient, game_name: string) {
    this.ENDPOINT = `${environment.base_url}/games/api/${game_name}/`;
  }

  private alertGenericError(): void {
    alert("Something went wrong. Please try again later.");
  }

  public getClientId(): string | undefined {
    return this.client_id;
  }

  public getRoomId(): string | undefined {
    return this.room_id;
  }

  public enterGame(

    room_id: string | null,
    successCallback: Function,
    invalidRoomCallback?: Function

  ): void {
    
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    let params = new HttpParams();
    if (room_id) params = params.set('room_id', room_id);

    this.http.get<any>(
      this.ENDPOINT,
      {
        params,
        headers,
        withCredentials: true,
        observe: 'response'
      }
    ).subscribe({
      next: response => {

        if (response.status === 200){
            
            const response_data = response.body.data;

            this.client_id = response_data['client_id'];
            this.room_id = response_data['room_id'];
            
            successCallback();

        }

      },

      error: response => {

        if (response.status === 404 && invalidRoomCallback){

          invalidRoomCallback();
          return;

        }

        this.alertGenericError();
      }

    });

  }

  protected postCommand(

    action: string,
    value: any | null,
    successCallback?: Function

  ): void {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Client-Id': this.client_id!
    });

    const body: any = {
      action: action
    };

    if (value !== null) {
      body.value = value;
    }

    this.http.post<any>(
      this.ENDPOINT,
      body,
      {
        headers,
        withCredentials: true,
        observe: 'response'
      }
    ).subscribe({
      next: response => {

        if (response.status === 204 && successCallback)
          successCallback();

      },

      error: response => {
        this.alertGenericError();
      }

    });

  }

}
